import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CancelQuoteComponent } from './shared/components/cancel-quote/cancel-quote.component';
import { ApproveCancellationComponent } from './shared/components/approve-cancellation/approve-cancellation.component';
import { CancelTokenGuard } from './core/guards/cancel-token.guard';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/main-layout/main-layout.module').then(
        (m) => m.MainLayoutModule,
      ),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./modules/onboarding-layout/onboarding-layout.module').then(
        (m) => m.OnboardingLayoutModule,
      ),
  },
  {
    path: 'third-parties',
    loadChildren: () =>
      import('./modules/third-parties-layout/third-parties-layout.module').then(
        (m) => m.ThirdPartiesLayoutModule,
      ),
  },
  {
    path: 'cancelation-quote/:tenant',
    component: CancelQuoteComponent,
  },
  {
    path: 'cancelation-quote',
    component: CancelQuoteComponent,
  },
  {
    path: 'cancel-approve/:id',
    canActivate: [CancelTokenGuard],
    component: ApproveCancellationComponent,
  },
  {
    path: 'public/client-cancellation',
    loadChildren: () =>
      import('./modules/client-cancellation/client-cancellation.module').then(
        (m) => m.ClientCancellationModule,
      ),
  },
  {
    path: 'customer-products-selection/:menuId/:domain',
    loadChildren: () =>
      import(
        './modules/customer-products-selection/customer-products-selection.module'
      ).then((m) => m.CustomerProductsSelectionModule),
  },
  {
    path: 'a',
    loadChildren: () =>
      import(
        './modules/claims/adjuster-indicators-ancillary/adjuster-indicators-ancillary.module'
      ).then((m) => m.AdjusterIndicatorsAncillaryModule),
  },
  {
    path: 'm',
    loadChildren: () =>
      import(
        './modules/claims/adjuster-indicators-mechanical/adjuster-indicators-mechanical.module'
      ).then((m) => m.AdjusterIndicatorsMechanicalModule),
  },
  {
    path: 'g',
    loadChildren: () =>
      import(
        './modules/claims/adjuster-indicators-gap/adjuster-indicators-gap.module'
      ).then((m) => m.AdjusterIndicatorsGapModule),
  },
  { path: 'client-claim', loadChildren: () => import('./modules/client-claim/client-claim.module').then(m => m.ClientClaimModule) },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
